import { forwardRef } from '@wordpress/element';
import { ToggleGroupControlOptionBase } from '../toggle-group-control-option-base';
import { useToggleGroupControlContext } from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
function UnforwardedToggleGroupControlOption(props, ref) {
  useToggleGroupControlContext('ToggleGroupControlOption');
  const {
    label,
    ...restProps
  } = props;
  const optionLabel = restProps['aria-label'] || label;
  return /*#__PURE__*/_jsx(ToggleGroupControlOptionBase, {
    ...restProps,
    "aria-label": optionLabel,
    ref: ref,
    children: label
  });
}

/**
 * `ToggleGroupControlOption` is a form component and is meant to be used as a
 * child of `ToggleGroupControl`.
 *
 * ```jsx
 * import {
 *   __experimentalToggleGroupControl as ToggleGroupControl,
 *   __experimentalToggleGroupControlOption as ToggleGroupControlOption,
 * } from '@wordpress/components';
 *
 * function Example() {
 *   return (
 *     <ToggleGroupControl
 *       label="my label"
 *       value="vertical"
 *       isBlock
 *     >
 *       <ToggleGroupControlOption value="horizontal" label="Horizontal" />
 *       <ToggleGroupControlOption value="vertical" label="Vertical" />
 *     </ToggleGroupControl>
 *   );
 * }
 * ```
 */
export const ToggleGroupControlOption = forwardRef(UnforwardedToggleGroupControlOption);
ToggleGroupControlOption.displayName = 'ToggleGroupControlOption';
export default ToggleGroupControlOption;